var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97917 14.6673C11.6611 14.6673 14.6458 11.6825 14.6458 8.00065C14.6458 4.31875 11.6611 1.33398 7.97917 1.33398C4.29727 1.33398 1.3125 4.31875 1.3125 8.00065C1.3125 11.6825 4.29727 14.6673 7.97917 14.6673Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14536 9.68719V6.31385C7.14536 5.99385 7.01203 5.86719 6.67203 5.86719H5.80536C5.46536 5.86719 5.33203 5.99385 5.33203 6.31385V9.68719C5.33203 10.0072 5.46536 10.1339 5.80536 10.1339H6.66536C7.01203 10.1339 7.14536 10.0072 7.14536 9.68719Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 9.68719V6.31385C10.666 5.99385 10.5327 5.86719 10.1927 5.86719H9.33271C8.99271 5.86719 8.85938 5.99385 8.85938 6.31385V9.68719C8.85938 10.0072 8.99271 10.1339 9.33271 10.1339H10.1927C10.5327 10.1339 10.666 10.0072 10.666 9.68719Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/PauseIcon.dc1824e6062c8be6841856dbb16b8fcb.svg";
export { ForwardRef as ReactComponent };